/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import PropTypes from "prop-types";
import TextInput from "../BasicInputs/TextInput.jsx";

const isMobile = false


// This component displays the search element for a table
class TableSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInput: "",
            isOpen: false
        };
        this.searchInputComponent = React.createRef();

    }


    componentDidMount() {
        if (!isMobile) { // Do not focus on the mobile as it will open the keyboard and block the hole screen.
            // automatically set the focus in the search bar on page display
            this.searchInputComponent.focus();
        }


    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.searchInput !== this.props.searchInput) {
            if (this.props.searchInput !== this.state.searchInput) {
                this.setState({searchInput: this.props.searchInput})
            }
        }

    }

    render() {
        let {onKeyDown, suggestion, className = "", filterTwinId, onTwinChange} = this.props

        return (<div className={"flex gap-2 my-2"}>


                <div className={"grow"}>


                    <TextInput className={"bg-white"} hasSearch={true} innerRef={(input) => {
                        this.searchInputComponent = input;
                    }}
                               value={this.state.searchInput}
                               onChange={(value) => {
                                   this.props.OnSearchInput(value)
                                   this.setState({searchInput: value})
                               }}
                               onKeyDown={onKeyDown}
                               suggestion={suggestion}
                               placeholder={this.props.placeholder ?? "Search "}

                    />
                </div>

            </div>
        )
    };
}

export default TableSearch;

TableSearch.propTypes = {
    columns: PropTypes.array,
    OnSearchInput: PropTypes.func,
    OnSearchColumnChange: PropTypes.func,
    preSelectedColumn: PropTypes.string,
}